import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { SelectModule } from 'ng2-select';
import { CompanyComponent} from './company.component';
import { ComponentsModule } from '../shared/components/components.module';
import { CompanyRoutes } from './company.routing';
import { MaterialModule } from '../app.module';
import { ContactsModule } from '../contacts/contacts.module';
import { ContactsComponent } from '../contacts/contacts.component';

import { NuevoPaciente } from '../customers/customers.component';
import { CustomersModule } from '../customers/customers.module';
import { ModulosModule } from '../modulos/modulos.module';
import { VendorComponent } from '../modulos/vendors/vendor/vendor.component';
import { TableContactPartyPickupComponent } from './table-contact-party-pickup/table-contact-party-pickup.component';
import { CustomAutocompleteComponent } from 'src/app/ui-components';


@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(CompanyRoutes),
        FormsModule,
        ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule,
    ContactsModule,
    CustomersModule,
    ModulosModule,
    CustomAutocompleteComponent
    ],
    entryComponents: [CompanyComponent, ContactsComponent, NuevoPaciente, VendorComponent],
    declarations: [CompanyComponent, TableContactPartyPickupComponent]
})

export class CompanyModule {}